import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import ReactGA from 'react-ga4'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'audioworklet-polyfill'
import 'focus-visible'
import { MoteEntryPointProviders } from '@/entrypoint'
import { ReferralUsageTracker } from '@/referral'
import { getSentryConfig } from '@mote/config/external/sentry.config'
import * as Sentry from '@sentry/react'
import { getWebVersion } from './shared/getWebVersion'
import { WebRouting } from './Routing'

ReactGA.initialize('G-B681F1D2Q7')

Sentry.init(
  getSentryConfig({
    dsn: 'https://70d7009086954f558c4f2f3e4e977bb6@sentry.io/5181853'
  })
)

Sentry.setTag('webVersion', getWebVersion())

export function MoteAppEntryPoint() {
  return (
    <Router>
      <MoteEntryPointProviders>
        <ReferralUsageTracker>
          <WebRouting />
        </ReferralUsageTracker>
        <ToastContainer />
      </MoteEntryPointProviders>
    </Router>
  )
}
